import { render, staticRenderFns } from "./AuthBatchTransfer.vue?vue&type=template&id=13d1bf77&scoped=true&"
import script from "./AuthBatchTransfer.vue?vue&type=script&lang=js&"
export * from "./AuthBatchTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1bf77",
  null
  
)

export default component.exports